import type { PaginationExtendedData } from '#types';

type P<TInput, TOutput, TPagination extends PaginationExtendedData<TInput>> = {
  createItem: (item: TInput) => TOutput;
  pagination: TPagination;
};

export const createPaginationData = <TInput, TOutput, TPagination extends PaginationExtendedData<TInput>>({
  createItem,
  pagination: { data, limit, skip, total },
}: P<TInput, TOutput, TPagination>) => ({
  data: data.map((item) => createItem(item)),
  limit,
  skip,
  total,
});
